import { gql } from '@apollo/client'

export const SCHOOL_EXPORT_FIELDS = gql`
  fragment SchoolExportFields on SchoolExport {
    id
    schoolName
    package
    usedForTesting
    using_alerts
    using_cms
    using_community
    using_gradebook
    using_sis
    using_website
    sites {
      id
      label
      hostname
      isPrivate
    }
  }
`

export const SCHOOLS_EXPORT_QUERY = gql`
  query SchoolsExportQuery($hasCmsSites: Boolean, $package: String) {
    schoolsExport(hasCmsSites: $hasCmsSites, package: $package) {
      ...SchoolExportFields
    }
  }
  ${SCHOOL_EXPORT_FIELDS}
`

export const SCHOOL_PACKAGE_OPTIONS = [
  { value: 'legacy', label: 'Legacy' },
  { value: 'regular', label: 'Regular' },
  { value: 'unlimited', label: 'Unlimited' },
  { value: 'reservations_unlimited', label: 'Unlimited with reservations' },
  { value: 'free', label: 'Free School' },
  { value: 'single_classroom', label: 'Single Classroom' },
  { value: 'distance_learning', label: 'Distance Learning' },
  { value: 'new_school', label: 'New School' },
  { value: 'enterprise', label: 'Enterprise' },
  { value: 'cms_only', label: 'CMS Only' },
]

export const packageOptionsForExport = (packages = []) => {
  const known = new Set(SCHOOL_PACKAGE_OPTIONS.map((option) => option.value))
  const extras = (packages || [])
    .map((pkg) => pkg?.type)
    .filter((type) => type && !known.has(type))
    .sort((a, b) => a.localeCompare(b))
    .map((type) => ({ value: type, label: type }))
  return [...SCHOOL_PACKAGE_OPTIONS, ...extras]
}

export const SCHOOLS_EXPORT_PAGE_QUERY = gql`
  query SchoolsExportPageQuery($page: Int, $limit: Int, $search: String) {
    schoolsExportPage(page: $page, limit: $limit, search: $search) {
      total
      page
      limit
      items {
        ...SchoolExportFields
      }
    }
  }
  ${SCHOOL_EXPORT_FIELDS}
`

export const ACCOUNT_FIELDS = [
  { key: 'using_alerts', label: 'Alerts' },
  { key: 'using_cms', label: 'CMS' },
  { key: 'using_community', label: 'Community' },
  { key: 'using_gradebook', label: 'Gradebook' },
  { key: 'using_sis', label: 'SIS' },
  { key: 'using_website', label: 'Website' },
]

const siteList = (row) => row.sites || []

export const EXPORT_COLUMNS = [
  { label: 'ID', value: (row) => row.id },
  { label: 'School Name', value: (row) => row.schoolName },
  { label: 'Package', value: (row) => row.package },
  { label: 'Test', value: (row) => (row.usedForTesting ? 'Yes' : 'No') },
  {
    label: 'Site Names',
    value: (row) =>
      siteList(row)
        .map((site) => site.label || site.hostname || 'Untitled site')
        .join('\n'),
  },
  {
    label: 'Site Hostnames',
    value: (row) =>
      siteList(row)
        .map((site) => site.hostname || '')
        .join('\n'),
  },
  {
    label: 'Site Privacy',
    value: (row) =>
      siteList(row)
        .map((site) => (site.isPrivate ? 'private' : 'public'))
        .join('\n'),
  },
]

export const PAGE_SIZE = 25
